module.exports = __webpack_public_path__ + "static/image_5-464d40c8daa2c6e27caeb301b7b4c864.jpg";